import { render, staticRenderFns } from "./OrderSettlement.vue?vue&type=template&id=36b338a4&scoped=true&"
import script from "./OrderSettlement.vue?vue&type=script&lang=js&"
export * from "./OrderSettlement.vue?vue&type=script&lang=js&"
import style0 from "./OrderSettlement.vue?vue&type=style&index=0&id=36b338a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b338a4",
  null
  
)

export default component.exports